<template>
  <Modal v-model="visible" :mask-closable="false" title="详情" :footer-hide="true" width="1200" class="my-modal">
    <div class="search-box ban3">
      <div class="input-item">
        <span class="label">保单号</span>
        <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">所属机构/团队</span>
        <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
      </div>
      <div class="input-item">
        <span class="label">出单业务员</span>
        <lzSelect placeholder="请输入姓名或工号搜索" v-model="searchParams.salesmanId" :remote-method="getUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </div>
      <div class="input-item">
        <span class="label">续费状态</span>
        <Select v-model="searchParams.payState" :transfer="true" clearable>
          <Option value="1">待续费</Option>
          <Option value="2">续费成功</Option>
          <Option value="3">续费失败</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="daochu()">导出</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <!-- 保单状态 -->
        <template slot-scope="{ row }" slot="policyStatus">
          <lzDicTxt dicType="POLICY_STATUS" :dicCode="row.policyStatus"></lzDicTxt>
        </template>
        <!-- 续费状态 -->
        <template slot-scope="{ row }" slot="renewalStatus">
          <span class="my-tag" v-if="row.renewalStatus == 1">待续费</span>
          <span class="my-tag green" v-else-if="row.renewalStatus == 2">续费成功</span>
          <span class="my-tag red" v-else-if="row.renewalStatus >= 3">续费失败</span>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>
  </Modal>
</template>

<script>
import { pageTool } from '@/api/mixins';
import { config } from './detailModal.config.js';
import selectTree from '@/components/system/selectTree3';
import lzSelect from '@/components/commons/lzSelect';
import lzDicTxt from '@/components/commons/lzDicTxt';
export default {
  mixins: [pageTool, config],
  components: {
    lzDicTxt,
    selectTree,
    lzSelect,
  },
  data() {
    return {
      visible: false,
      userInfo: {},
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    open(rowData) {
      this.visible = true;
      this.searchParams = {
        rateId: rowData.id
      };
      this.initListAjax('/buz/renewalRate/queryRenewalPolicyList');
    },
    daochu() {
      if(!this.$units.pointAction('renewalManage_05_export')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      if (!this.tableData.length) {
        this.$notice.msg('暂无可导出数据');
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/renewalRate/exportRenewalPolicyList', params, 'POST');
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.orgId = '';
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = '';
        this.searchParams.groupId = '';
      }
    },
    setListParams(params) {
      delete params.applyOrgId;
    },
    // 业务员搜索
    getUserList(keyword) {
      if (!keyword) {
        return;
      }
      let params = {
        orgId: this.userInfo.organId,
        userName: keyword
      };
      return this.$http({
        url: '/buz/userBase/getSubUser',
        type: 'get',
        data: params
      }).then(res => {
        return res.data;
      });
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
